import { render } from "./ParkingFleetDetailsHistory.vue?vue&type=template&id=82aa0558"
import script from "./ParkingFleetDetailsHistory.vue?vue&type=script&lang=js"
export * from "./ParkingFleetDetailsHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__